export default __webpack_public_path__ + "static/new6-3-3654bb6f80829371a28d08cac1a7ecc3.jpg";